import { useLearningObjectCommonData } from '../components/providers/LearningObjectCommonDataProvider';
import { useTheme } from '../queries/theme';

export function useParentTheme() {
  const { themeId } = useLearningObjectCommonData();
  return useTheme(themeId);
}
